export const TILE = 16;
export const VIEW_W = 480;
export const VIEW_H = 270;

export const PLAYER_SPEED = 90;
export const MONSTER_SPEED = 22;

export const SAVE_KEY = "mathrpg.save";
export const SAVE_VERSION = 3;

export const DEFAULT_TIMER_SECONDS = 30;
/** Answering within this fraction of the timer counts as a Quick Strike. */
export const QUICK_ANSWER_FRACTION = 1 / 3;
export const QUICK_MULTIPLIER = 1.5;
export const STREAK_FOR_CRITICAL = 5;
export const CRITICAL_MULTIPLIER = 2;

export const BASE_WEAPON_ATK = 5;
export const ATK_PER_LEVEL = 2;
export const HP_PER_LEVEL = 5;
export const XP_PER_CORRECT = 3;
export const POTION_HEAL = 15;
export const GOLD_LOSS_ON_DEFEAT = 0.1;
/** Gold paid to run away from a battle (capped by what the hero has). */
export const FLEE_COST = 3;
export const XP_PER_TRAINING_CORRECT = 1;
